import { FC, useEffect, useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, Select } from "@ht/components";
import CallOutlineIcon from "@ht/shared/fonts/deos-pis/call-outline-small";
import NoteOutlineIcon from "@ht/shared/fonts/deos-pis/note-outline-extra-small";
import AlertIcon from "@ht/shared/fonts/deos-pis/alert";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { openEFormModal, openRightPanel, updateSessionTag } from "../../../app/chat/chatSlice";
import Dots from "@ht/shared/fonts/deos-pis/dots";
import clsx from "clsx";
import DropdownMessageControlItem from "../../../components/dropdown/message/item";
import { IActiveRoom } from "../../../app/chat/types";
import { callStateChanged } from "../../../app/call/callSlice";
import { IOption } from "@ht/components/src/forms/form-elements/select";
import { useHttpRequest } from "../../../hooks/useHttpRequest";
import { MessageBox } from "../../../components/message-box";
import { setOnCall } from "../../../app/userState/userStateSlice";
import generateUuid from "../../../utils/generateUuid";
interface ICustomerData {
    id?: string
    profile_picture?: string,
    fullname?: string,
    email?: string[],
    dob?: Date,
    gender?: string,
    phone_number?: string[],
    religion?: string,
    address?: string,
    tenant_id?: string,
    room_id?: string,
    hideOptions?: boolean
}
const MessageOptions: FC<ICustomerData> = ({ phone_number, hideOptions, fullname }) => {
    const { sendRequest, abort } = useHttpRequest(process.env.REACT_APP_CHAT_SERVICE);
    const dispatch = useAppDispatch();
    const { callAvailable } = useAppSelector((state) => state.call);
    const { callState } = useAppSelector((state) => state.call);
    const { incomingRoom, activeRoom } = useAppSelector((state) => state.chat);
    const [selectedTag, setSelectedTag] = useState<IOption>();
    const [tag, setTag] = useState();
    const [tags, setTags] = useState<Array<{
        label: any; value: string;
    }>>([]);
    const [showMessageBox, setShowMessageBox] = useState(false);
    const [message, setMessage] = useState("");
    const closeMessageBoxHandler = () => {
        setShowMessageBox((prev) => !prev);
        setMessage("");
    };
    const getActiveRoomStorage = () => {
        const activeRoomStorage = localStorage.getItem("activeChatRoom");
        if (activeRoomStorage) {
            return JSON.parse(activeRoomStorage) as IActiveRoom;
        }
        return null;
    }
    
    const initiateCallSIP = (number: string) => {
        const activeRoomStorage = getActiveRoomStorage();
        if (activeRoomStorage) {
            const sessionid = incomingRoom.find(x => x.roomId == activeRoomStorage.roomId)?.sessionId

            const state = { ...callState }
            state.isCalling = true;
            state.callConnected = true;
            state.callType = "outgoing";
            state.callDestination = number.replace("+", "");
            state.callDescription = `Calling ${fullname}`;
            state.sessionId = sessionid ?? "";
            state.roomId = activeRoomStorage.roomId;
            state.username = activeRoomStorage.account;
            state.name = activeRoomStorage.account;

            dispatch(callStateChanged(state));
            dispatch(setOnCall("SIP Outgoing Call"));
            
        }

    }
    const interactionHandler = () => {
        dispatch(openRightPanel({ body: "INTERACTION" }));
    };
    const interactionHistoryHandler = () => {
        dispatch(openRightPanel({ body: "INTERACTION_HISTORY" }));
    };
    const viewProfileHandler = () => {
        dispatch(openRightPanel({ body: "CUSTOMER_PROFILE" }));
    };
    const viewEformHandler = () => {
        if (activeRoom.customerId == null) {
            setMessage("Please add contact first!");
            setShowMessageBox(true);
            return;
        }
        dispatch(openEFormModal({
            customerId: activeRoom.customerId,
            sessionId: activeRoom.sessionId,
            roomId: activeRoom.roomId,
            isDisabled: false,
            channel: activeRoom.channel
        }));
    };
    const tagChangeHanlder = async (event: any) => {
        setSelectedTag(event);
        await sendRequest({
            url: `/session-tag`,
            method: "post",
            body: {
                sessionId: activeRoom.sessionId,
                tag: event.value
            }
        });
        dispatch(updateSessionTag({ sessionId: activeRoom.sessionId, sessionTag: event.value }))
    }
    const loadTags = () => {
        const tagData = [
            { label: 'No Tag', value: 'no tag', color: "" },
            { label: 'Urgent', value: 'urgent', color: "text-red-900" },
            { label: 'Low', value: 'low', color: "text-yellow-900" },
        ];

        setTags(tagData.map(item => {
            return {
                label: (
                    <div className="text-base font-semibold text-gray-400 flex items-center gap-1">
                        <AlertIcon height={14} width={14} className={item.color} />
                        <div className="flex-nowrap">
                            {item.label}
                        </div>
                    </div>
                ),
                value: item.value
            }
        }));
    }
    const loadTagData = async () => {
        const result = await sendRequest({
            url: `/ChatSession/${activeRoom.sessionId}`,
            method: "get"
        });
        if (result?.data) {
            const session = result.data as any;
            setTag(session.session_tag);
        }
    }
    useEffect(() => {
        loadTags();
    }, []);
    useEffect(() => {
        if (activeRoom) loadTagData().catch(e => console.log(e));

        return () => {
            abort();
        }
    }, [activeRoom]);
    useEffect(() => {
        if (tag) {
            setSelectedTag(tags.find(a => a.value == tag));
        }
    }, [tag]);
    return (
        <>
            <MessageBox type="warning" visible={showMessageBox} closeHandler={closeMessageBoxHandler} title="Warning" message={message} />
            <div className="flex items-center ml-auto">
                <Select
                    name="tags"
                    onChange={tagChangeHanlder}
                    placeholder=" "
                    options={tags}
                    showBorder={false}
                    value={selectedTag}
                />
                {!hideOptions &&
                    <>
                        <div className="border border-gray-200 h-[20px] ml-2 mr-4"></div>
                        <div title="E-Form Consultation" className="mr-1 w-[32px] h-[32px] rounded-full hover:bg-gray-100 ">
                            <NoteOutlineIcon onClick={viewEformHandler}
                                width={20} height={20}
                                className="text-gray-400 text-lg hover:cursor-pointer m-[6px]" />
                        </div>

                        <div title="Call" className="mr-1">
                            <Dropdown className="block" direction="down" showIcon={false} shape>
                                <DropdownToggle
                                    variant="texted"
                                    iconButton
                                    size="lg"
                                    shape="ellipse"
                                    customStyle="only-icon"
                                    disabled={!callAvailable}
                                    className="text-[26px] w-[32px] h-[32px] pl-[6px] relative content-start"
                                >
                                    <CallOutlineIcon
                                        className={clsx(
                                            callAvailable ?
                                                "w-[20px] h-[20px] text-gray-400" : "text-gray-200"
                                        )}
                                    />
                                </DropdownToggle>
                                <DropdownMenu
                                    className={clsx(
                                        "rounded p-0 w-[200px] mt-[1.125rem] -mr-[1.2rem] border-t-0 right-0 left-auto"
                                    )}
                                >
                                    {phone_number?.map((phonenumber) => {
                                        const phonestring = (phonenumber ?? "").replace(/(?<=....).(?=..)/g, "*")
                                        return (
                                            <div className="dropdown-list rounded-t" key={`phn${generateUuid()}`} >
                                                <button disabled={!callAvailable} className="flex flex-row w-full items-center gap-[4px] px-2 py-2 border-b-[1px] border-gray-300 hover:bg-gray-100"
                                                    onClick={() => initiateCallSIP(phonenumber)}
                                                >
                                                    <CallOutlineIcon
                                                        width={20} height={20}
                                                        className="text-gray-400 text-lg hover:text-gray-500 hover:cursor-pointer mr-2" />
                                                    Call {phonestring}

                                                </button>
                                            </div>

                                        )
                                    })
                                    }
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                        <div className="border border-gray-200 h-[20px] ml-2 mr-3"></div>
                        <div className="sm:flex">
                            <Dropdown className="mr-3 block" direction="down" showIcon={false} shape>
                                <DropdownToggle
                                    variant="texted"
                                    iconButton
                                    size="lg"
                                    shape="ellipse"
                                    customStyle="only-icon"
                                    className="text-[26px] w-[32px] h-[32px] pl-1 relative content-start"
                                >
                                    <Dots
                                        className={clsx(
                                            "w-6 h-6 text-gray-400"
                                        )}
                                    />
                                </DropdownToggle>
                                <DropdownMenu
                                    className={clsx(
                                        "rounded p-0 !w-[9rem] mt-[1.125rem] -mr-[1.2rem] border-t-0 right-0 left-auto"
                                    )}
                                >
                                    <div className="dropdown-list rounded-t">
                                        <DropdownMessageControlItem onClick={viewProfileHandler} additionalClass="rounded-t"
                                            text="Customer Profile" />
                                    </div>
                                    <div className="dropdown-list rounded-b">
                                        <DropdownMessageControlItem onClick={interactionHistoryHandler} additionalClass="rounded-b"
                                            text="History" />
                                    </div>
                                    <div className="dropdown-list rounded-b">
                                        <DropdownMessageControlItem onClick={interactionHandler} additionalClass="rounded-b"
                                            text="End Conversation" />
                                    </div>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </>
                }
            </div >

        </>
    );
};

export default MessageOptions;
